module.exports = __webpack_public_path__ + "img/MEDIA056.ba7bfc36.jpg";